import React from 'react';

export const ProfileAnaxaInvest: React.FC = () => {
  return (
    <>
      <p>
        Are you wondering whether you should pull for Anaxa Eidolons or his
        Light Cone? Then this section is for you!
      </p>
      <blockquote className="firefly-order">
        <p>
          <strong className={`Wind`}>Anaxa S1</strong> &gt;{' '}
          <strong className={`Wind`}>Anaxa E1</strong> &gt;{' '}
          <strong className={`Wind`}>Anaxa E2</strong>
        </p>
      </blockquote>
      <ol>
        <li>
          <strong>Anaxa S1</strong> offers a similar DEF Reduction effect to his
          E1, with a slightly lower value at 12%. The main benefit of this Light
          Cone though, is the additional Energy to guarantee 2-turn Ultimates
          with ATK Rope, on top of the massive DMG boost, while also being a
          cheaper option than the Eidolon, making it a great pickup for those
          wanting to further invest into Anaxa. Anaxa without his Signature
          Light Cone does not generate enough Energy for 2-turn Ultimates,
          either requiring heavy rng or an Energy Rope which comes at a great
          cost of losing a significant portion of his personal DMG.
        </li>
        <li>
          <strong>Anaxa E1</strong> offers a 16% DEF Reduction when using his
          Skill, and an extra Skill Point once per battle. The 16% DEF Reduction
          alone for other allies, is a minor boost without additional sources of
          DEF Reduction, and only gets stronger when stacking it, such as for
          Anaxa himself with 28% DEF Ignore through his Traces.
        </li>
        <li>
          <strong>Anaxa E2</strong> reduces all enemies' All-Types RES by 20%,
          and triggers the Talent's Weakness Implant when they enter battle. The
          extra Weakness Implant paired with his Technique can Implant 2
          additional Weakness Types at the start of battle to immediately put
          enemies under "Qualitive Disclosure" to trigger the extra Skill from
          his Talent, and the All-Type RES is a simple and permanent ~20% DMG
          boost for all of his teams, making it a strong Eidolon to pick up
          although not cheap.
        </li>
      </ol>
    </>
  );
};
